export const skipToMessage = "hSa";
export const readingPane = "iSa";
export default {skipToMessage,readingPane};